import React from 'react';
import TurfBookingsForm from './TurfBookingsForm';

const EditTurfBookingPage = () => {
    return <TurfBookingsForm formType="edit" />;
};

export default EditTurfBookingPage;
